import { Message } from "google-protobuf";
import { ERROR_TIMEOUT } from "../../constants/errors";
import { MessageRequest } from "../../constants/protoTable";
import { ErrorResponse } from "../../proto/Error_pb";
import ServerError from "../Error/ServerError";
import { ApiOptions } from "./index";

export default class MockedRequestWrapper {
  private readonly _done: Function;
  private readonly _resolve: Function;
  private readonly _reject: Function;
  private readonly _actionId: number;
  private readonly _proto: any;
  private readonly _options: ApiOptions;
  private _timeout?: any;

  constructor(resolve: Function, reject: Function, done: Function, actionId: number, proto: any, options: ApiOptions) {
    this._resolve = resolve;
    this._reject = reject;
    this._done = done;
    this._actionId = actionId;
    this._proto = proto;
    this._options = options;
  }

  private _promise: Promise<any> | undefined;

  /**
   * @return {Promise}
   */
  get promise(): Promise<any> | undefined {
    return this._promise;
  }

  /**
   * @param {Promise} value
   */
  set promise(value: Promise<any> | undefined) {
    this._promise = value;
  }

  get actionId() {
    return this._actionId;
  }

  get proto(): any {
    return this._proto;
  }

  get options(): ApiOptions {
    return this._options;
  }

  startTimeout() {
    if (this._timeout) {
      throw new Error("Cannot start timeout multiple times");
    }

    this._timeout = setTimeout(() => {
      const errorResponse = new ErrorResponse();
      errorResponse.setMajorCode(ERROR_TIMEOUT);
      errorResponse.setMinorCode(1);
      this.reject(new ServerError(errorResponse, this.actionId));
    }, this._options.timeout);
  }

  resolve(value: Message) {
    try {
      this._resolve(value);
    } finally {
      this._done();
    }
  }

  reject(reason: any) {
    try {
      if (reason instanceof ServerError) {
        this._reject(reason);
      }
    } finally {
      const request = this.proto.getRequest();
      this._done(request?.getId());
    }
  }
}
